import { CSSProperties } from 'react';
import type { ConnStatusDTO } from '@webip/shared/src/dto/connection_status';
import styles from './StatusDot.module.css';

type StatusMeta = { label: string; color: string };

const STATUS_META: Record<ConnStatusDTO, StatusMeta> = {
    online:   { label: 'Online',       color: 'var(--status-online)' },
    standby:  { label: 'Standby',      color: 'var(--status-info)' },
    partial:  { label: 'Parcial',      color: 'var(--status-warn)' },
    offline:  { label: 'Offline',      color: 'var(--status-offline)' },
    unknown:  { label: 'Desconhecido', color: 'var(--status-idle)' },
};

type StatusDotProps = {
    status: ConnStatusDTO;
    /** Texto exibido ao lado do círculo. Default: rótulo padrão do status. */
    label?: string;
    /** Quando false, mostra apenas o círculo (sem texto). */
    showLabel?: boolean;
    title?: string;
    style?: CSSProperties;
};

/**
 * Indicador de status de conexão: um círculo colorido (verde/amarelo/vermelho/
 * cinza) com rótulo opcional. Usa as variáveis CSS --status-* do tema, as
 * mesmas da tela de appliances.
 */
const StatusDot = ({ status, label, showLabel = true, title, style }: StatusDotProps) => {
    const meta = STATUS_META[status] ?? STATUS_META.unknown;
    return (
        <span className={styles.wrapper} style={style} title={title ?? meta.label}>
            <span className={styles.dot} style={{ backgroundColor: meta.color }} />
            {showLabel && <span className={styles.label}>{label ?? meta.label}</span>}
        </span>
    );
};

export default StatusDot;
